export const clampPercentage = (value: number) => Math.min(Math.max(value, 0), 100);

export const formatTwoDigitCount = (value: number) => String(value).padStart(2, '0');
